<template>
    <v-card
        elevation="2"
        outlined
        class="pa-5"
    >
        <v-card-title>Counties</v-card-title>
        <v-data-table
            :headers="headers"
            :items="countyData"
            item-key="code"
            class="row-pointer"
            @click:row="filterCounty"
        />
    </v-card>
</template>
<script>
import   {setCountyFilter}  from '../services/ticketTabs';
export default {
    props: {
        countyData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Code',
                    value: 'fips',
                },
                {
                    text: 'County',
                    value: 'countyName',
                },
                {
                    text: 'Total Tickets',
                    value: 'count',
                    align: 'end',
                },                
            ],
        };
    },    
    methods: {
        filterCounty(item) {            
            setCountyFilter(item.fips);
        }
    },
};

export function formatTicketCounties(counties, overviewCounties) {
    return overviewCounties.map(overviewCounty => {
        const countyObject = {};
        for(let county of counties) {
            // ignore the timestamp at position 0
            const [ , fips, state, name ] = county;
            if(overviewCounty.fips === fips) {
                Object.assign(countyObject, overviewCounty);
                countyObject.countyName = `${name}, ${state}`;
                return countyObject;
            }
        }
    });
}

</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>